import { Text } from '@chakra-ui/react';
import * as React from 'react';

export const ExternalRegistrationMessage: React.FC = () => {
  return <Text>Registration is hosted on an external platform</Text>;
};
